import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "src/router/RoutersCst";

import BrandAsset from "@pages/Contents/Corporate/BrandAsset";

const useCorporateBrandAsset = () => {
  const { isInclude } = useIsInclude();

  return {
    path: "brand-asset",
    children: [
      {
        index: true,
        path: "",
        element: (
          <ProtectedRoute isAllowed={isInclude("corporate.brandasset.read")}>
            <BrandAsset />
          </ProtectedRoute>
        ),
      },
    ],
  };
};

export default useCorporateBrandAsset;
